import React from "react";
import { Route, Switch } from "react-router-dom";

import { ThemeProvider } from "@mui/material/styles";
import PORTTheme from "../../../themes/PORTTheme";

import Dashboard from "./Dashboard";
import Activity from "./Activity/Activity";
import ActivityList from "./Activity/ActivityList";
import Note from "./Note/Note";
import NoteList from "./Note/NoteList";
import Resource from "./Resource/Resource";
import ResourceList from "./Resource/ResourceList";
import CategoryList from "./Category/CategoryList";
import PDPList from "./PDP/PDPList";
import DevelopmentNeed from "./DevelopmentNeed/DevelopmentNeed";
import DevelopmentNeedList from "./DevelopmentNeed/DevelopmentNeedList";
import PDP from "./PDP/PDP";
import Qualification from "./Qualification/Qualification";
import QualificationList from "./Qualification/QualificationList";

const PortfolioRouter = () => (
    <ThemeProvider theme={PORTTheme}>
        <Switch>
            <Route path="/portfolio/activities/:id" component={Activity} />
            <Route path="/portfolio/activities" component={ActivityList} />
            <Route path="/portfolio/categories" component={CategoryList} />
            <Route path="/portfolio/pdps/:id/:appraiseeUUID?" component={PDP} />
            <Route path="/portfolio/pdps" component={PDPList} />
            <Route path="/portfolio/notes/:id" component={Note} />
            <Route path="/portfolio/notes" component={NoteList} />
            <Route path="/portfolio/resources/:id" component={Resource} />
            <Route path="/portfolio/resources" component={ResourceList} />
            <Route
                path="/portfolio/qualifications/:id"
                component={Qualification}
            />
            <Route
                path="/portfolio/qualifications"
                component={QualificationList}
            />
            <Route
                path="/portfolio/developmentneeds/:id"
                component={DevelopmentNeed}
            />
            <Route
                path="/portfolio/developmentneeds"
                component={DevelopmentNeedList}
            />
            <Route path="/portfolio/" component={Dashboard} />
        </Switch>
    </ThemeProvider>
);

export default PortfolioRouter;
